import { supabase } from "./supabase";

// Exact (case insensitive) match for .ilike(): escape the LIKE wildcards so
// an email like "a_b@x.com" cannot also match "aXb@x.com".
export function likeExact(value) {
  return String(value || "").trim().replace(/[\\%_]/g, function (m) { return "\\" + m; });
}

export function registerErrorMessage(err) {
  var m = String((err && err.message) || "");
  if (m.indexOf("already_registered") !== -1) return "This account is already fully set up. Please sign out and sign in again.";
  if (m.indexOf("already_member") !== -1) return "This email already belongs to a team. Please sign out and sign in again.";
  if (m.indexOf("invalid_key") !== -1) return "Invalid license key. Please check and try again.";
  if (m.indexOf("key_used") !== -1) return "This license key has already been used.";
  if (m.indexOf("key_suspended") !== -1) return "This license key has been suspended. Contact support.";
  if (m.indexOf("company_required") !== -1) return "Please enter your company name.";
  if (m.indexOf("not_signed_in") !== -1) return "Your session has ended. Please sign in again.";
  return "Account setup failed. Please try again." + (m ? " (" + m + ")" : "");
}

// Default WhatsApp templates for a new company (used by Login and Finish Setup)
export async function seedDefaultTemplates(companyId, companyName) {
  var rows = [
    { company_id: companyId, label: "Appointment Reminder", text: "Hi {name}, just a reminder that your window blinds installation is scheduled for tomorrow. Please ensure someone is home to provide access. Thank you! " + companyName },
    { company_id: companyId, label: "Quote Follow-Up", text: "Hi {name}, I wanted to follow up on the quote we sent you. Do you have any questions or would you like to proceed? We're happy to help! " + companyName },
    { company_id: companyId, label: "Job Complete: Review Request", text: "Hi {name}, thank you for choosing us! We hope you're loving your new window blinds. If you're happy with our service, we'd really appreciate a Google review, it helps us a lot! " + companyName },
    { company_id: companyId, label: "Initial Inquiry Response", text: "Hi {name}, thank you for reaching out! We'd love to help with your window blinds. We offer free measurements and competitive pricing. When would be a good time to schedule a visit? " + companyName },
    { company_id: companyId, label: "Payment Reminder", text: "Hi {name}, this is a friendly reminder that your balance for the recent installation is outstanding. Please let us know your preferred payment method. Thank you! " + companyName },
  ];
  var { error } = await supabase.from("whatsapp_templates").insert(rows);
  if (error) {
    var { error: error2 } = await supabase.from("whatsapp_templates").insert(rows);
    if (error2) console.error("Template seeding failed:", error2.message);
  }
}
